import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const RowAdd = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function RowAdd({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.5 4C2.5 3.44772 2.94772 3 3.5 3H20.5C21.0523 3 21.5 3.44772 21.5 4V6C21.5 6.55228 21.0523 7 20.5 7H3.5C2.94771 7 2.5 6.55228 2.5 6V4ZM4 5.5V4.5H20V5.5H4Z'
        fill={color}
      />
      <path
        d='M4.25 16.5V18.25H2.5C2.22386 18.25 2 18.4739 2 18.75V19.25C2 19.5261 2.22386 19.75 2.5 19.75H4.25V21.5C4.25 21.7761 4.47386 22 4.75 22H5.25C5.52614 22 5.75 21.7761 5.75 21.5V19.75H7.5C7.77614 19.75 8 19.5261 8 19.25V18.75C8 18.4739 7.77614 18.25 7.5 18.25H5.75V16.5C5.75 16.2239 5.52614 16 5.25 16H4.75C4.47386 16 4.25 16.2239 4.25 16.5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.5 10C2.94772 10 2.5 10.4477 2.5 11V13C2.5 13.5523 2.94771 14 3.5 14H20.5C21.0523 14 21.5 13.5523 21.5 13V11C21.5 10.4477 21.0523 10 20.5 10H3.5ZM4 11.5V12.5H20V11.5H4Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 18C10 17.4477 10.4477 17 11 17H20.5C21.0523 17 21.5 17.4477 21.5 18V20C21.5 20.5523 21.0523 21 20.5 21H11C10.4477 21 10 20.5523 10 20V18ZM11.5 19.5V18.5H20V19.5H11.5Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'row-add-icon-svg'} iconRender={iconRender} {...props} />;
});

export default RowAdd;
